"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = exports.imageRatioArray = exports.gridLinksNumberArray = exports.carouseLinksNumberArray = exports.photoLinksViewArray = exports.photoLinksThemeArray = exports.carouselImageSizeStrategy = exports.gridImageSizeStrategy = exports.ImageRatio = exports.GridLinksNumber = exports.CarouseLinksNumber = exports.PhotoLinksView = exports.PhotoLinksTheme = exports.MOBILE_GAP = exports.DEFAULT_GAP = void 0;

var _const = require("../../const");

var _gridImageSizeStrateg, _carouselImageSizeStr;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_GAP = 30;
exports.DEFAULT_GAP = DEFAULT_GAP;
var MOBILE_GAP = 20;
exports.MOBILE_GAP = MOBILE_GAP;
var PhotoLinksTheme;
exports.PhotoLinksTheme = PhotoLinksTheme;

(function (PhotoLinksTheme) {
  PhotoLinksTheme["WHITE"] = "white";
  PhotoLinksTheme["SEASHELL"] = "seashell";
  PhotoLinksTheme["SEASHELL_CROPPED"] = "seashell-cropped";
  PhotoLinksTheme["MOCASSIN"] = "mocassin";
  PhotoLinksTheme["MOCASSIN_CROPPED"] = "mocassin-cropped";
  PhotoLinksTheme["CLARET"] = "claret";
  PhotoLinksTheme["BLACK"] = "black";
})(PhotoLinksTheme || (exports.PhotoLinksTheme = PhotoLinksTheme = {}));

var PhotoLinksView;
exports.PhotoLinksView = PhotoLinksView;

(function (PhotoLinksView) {
  PhotoLinksView["CAROUSEL"] = "carousel";
  PhotoLinksView["GRID"] = "grid";
})(PhotoLinksView || (exports.PhotoLinksView = PhotoLinksView = {}));

var CarouseLinksNumber;
exports.CarouseLinksNumber = CarouseLinksNumber;

(function (CarouseLinksNumber) {
  CarouseLinksNumber["FOUR"] = "4";
  CarouseLinksNumber["SIX"] = "6";
})(CarouseLinksNumber || (exports.CarouseLinksNumber = CarouseLinksNumber = {}));

var GridLinksNumber;
exports.GridLinksNumber = GridLinksNumber;

(function (GridLinksNumber) {
  GridLinksNumber["THREE"] = "3";
  GridLinksNumber["FOUR"] = "4";
})(GridLinksNumber || (exports.GridLinksNumber = GridLinksNumber = {}));

var ImageRatio;
exports.ImageRatio = ImageRatio;

(function (ImageRatio) {
  ImageRatio["SQUARE"] = "1:1";
  ImageRatio["PORTRAIT"] = "3:2";
})(ImageRatio || (exports.ImageRatio = ImageRatio = {}));

var gridImageSizeStrategy = (_gridImageSizeStrateg = {}, _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.DESKTOP, GridLinksNumber.THREE, ImageRatio.SQUARE], {
  width: 342,
  height: 342
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.DESKTOP, GridLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 249,
  height: 249
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.DESKTOP, GridLinksNumber.THREE, ImageRatio.PORTRAIT], {
  width: 342,
  height: 514
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.DESKTOP, GridLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 249,
  height: 374
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.TABLET, GridLinksNumber.THREE, ImageRatio.SQUARE], {
  width: 216,
  height: 216
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.TABLET, GridLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 154,
  height: 154
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.TABLET, GridLinksNumber.THREE, ImageRatio.PORTRAIT], {
  width: 216,
  height: 324
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.TABLET, GridLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 154,
  height: 231
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.MOBILE, GridLinksNumber.THREE, ImageRatio.SQUARE], {
  width: 154,
  height: 154
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.MOBILE, GridLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 154,
  height: 154
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.MOBILE, GridLinksNumber.THREE, ImageRatio.PORTRAIT], {
  width: 154,
  height: 231
}), _defineProperty(_gridImageSizeStrateg, [_const.DeviceName.MOBILE, GridLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 154,
  height: 231
}), _gridImageSizeStrateg);
exports.gridImageSizeStrategy = gridImageSizeStrategy;
var carouselImageSizeStrategy = (_carouselImageSizeStr = {}, _defineProperty(_carouselImageSizeStr, [_const.DeviceName.DESKTOP, CarouseLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 249,
  height: 249,
  slides: 4
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.DESKTOP, CarouseLinksNumber.SIX, ImageRatio.SQUARE], {
  width: 156,
  height: 156,
  slides: 6
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.DESKTOP, CarouseLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 249,
  height: 374,
  slides: 4
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.DESKTOP, CarouseLinksNumber.SIX, ImageRatio.PORTRAIT], {
  width: 156,
  height: 234,
  slides: 6
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.TABLET, CarouseLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 179,
  height: 179,
  slides: 4
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.TABLET, CarouseLinksNumber.SIX, ImageRatio.SQUARE], {
  width: 127,
  height: 127,
  slides: 3
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.TABLET, CarouseLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 179,
  height: 269,
  slides: 4
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.TABLET, CarouseLinksNumber.SIX, ImageRatio.PORTRAIT], {
  width: 127,
  height: 191,
  slides: 3
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.MOBILE, CarouseLinksNumber.FOUR, ImageRatio.SQUARE], {
  width: 217,
  height: 217,
  slides: 1
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.MOBILE, CarouseLinksNumber.SIX, ImageRatio.SQUARE], {
  width: 217,
  height: 217,
  slides: 1
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.MOBILE, CarouseLinksNumber.FOUR, ImageRatio.PORTRAIT], {
  width: 217,
  height: 351,
  slides: 1
}), _defineProperty(_carouselImageSizeStr, [_const.DeviceName.MOBILE, CarouseLinksNumber.SIX, ImageRatio.PORTRAIT], {
  width: 217,
  height: 351,
  slides: 1
}), _carouselImageSizeStr);
exports.carouselImageSizeStrategy = carouselImageSizeStrategy;
var photoLinksThemeArray = Object.values(PhotoLinksTheme);
exports.photoLinksThemeArray = photoLinksThemeArray;
var photoLinksViewArray = Object.values(PhotoLinksView);
exports.photoLinksViewArray = photoLinksViewArray;
var carouseLinksNumberArray = Object.values(CarouseLinksNumber);
exports.carouseLinksNumberArray = carouseLinksNumberArray;
var gridLinksNumberArray = Object.values(GridLinksNumber);
exports.gridLinksNumberArray = gridLinksNumberArray;
var imageRatioArray = Object.values(ImageRatio);
exports.imageRatioArray = imageRatioArray;
var settings = {
  infinite: true,
  slidesToShow: 6,
  arrows: true,
  swipeToSlide: true,
  dots: false,
  lazyLoad: 'progressive'
};
exports.settings = settings;